import { OnboardingDetailedStep } from "@shared/features/onboarding/types";
import localStorageService from "utils/localStorageService";
import { ONBOARDING_STEP_KEY } from "@shared/features/onboarding/constants";
import { ONBOARDING_DETAILED_STEP_TO_PATH } from "features/onboarding/common/constants";
import { GetUpdatedPathType } from "types";

export const getOnboardingLocalStorageValue = () => {
  const onboardingLocalStorageValue: string | null =
    localStorageService.getValue(ONBOARDING_STEP_KEY);
  if (onboardingLocalStorageValue)
    return JSON.parse(onboardingLocalStorageValue);
};

export const updateOnboardingLocalStorageKey = (
  userId: number,
  step: OnboardingDetailedStep
) => {
  let userToStepMapping = getOnboardingLocalStorageValue() || {};
  userToStepMapping = { ...userToStepMapping, [userId]: step };

  localStorageService.setValue(
    ONBOARDING_STEP_KEY,
    JSON.stringify(userToStepMapping)
  );
};

export const changeOnboardingStep = (
  userId: number,
  step: OnboardingDetailedStep,
  historyPush: (path: string) => void,
  getUpdatedPath?: GetUpdatedPathType,
  queryToAppend?: Record<string, string>
) => {
  updateOnboardingLocalStorageKey(userId, step);
  let path = ONBOARDING_DETAILED_STEP_TO_PATH[step];
  if (getUpdatedPath && queryToAppend) {
    path = getUpdatedPath(queryToAppend, undefined, path);
  }
  historyPush(path);
};

export const didUserSkipOnboarding = (userId: number) => {
  return (
    getOnboardingLocalStorageValue()?.[userId] === OnboardingDetailedStep.SKIP
  );
};
